import React from "react";
import { NavDropdown } from "react-bootstrap";

// This component is a menu collection of actions related to pinning/unpinning
// rows to top/bottom of the Ag-Grid
function PinSelector(props) {
  const { gridApi } = props;

  const pinTop = () => {
    const selected = gridApi.getSelectedRows();
    if (selected && selected.length > 0) {
      gridApi.setPinnedTopRowData(selected);
    }
  };

  const pinBottom = () => {
    const selected = gridApi.getSelectedRows();
    if (selected && selected.length > 0) {
      gridApi.setPinnedBottomRowData(selected);
    }
  };

  const unPinSelected = () => {
    const selected = gridApi.getSelectedRows();
    let pinnedTop = [];
    for (let i = 0; i < gridApi.getPinnedTopRowCount(); i++) {
      pinnedTop.push(gridApi.getPinnedTopRow(i).data);
    }
    let pinnedBottom = [];
    for (let i = 0; i < gridApi.getPinnedBottomRowCount(); i++) {
      pinnedBottom.push(gridApi.getPinnedBottomRow(i).data);
    }
    if (selected && selected.length > 0) {
      pinnedTop = pinnedTop.filter((row) => !selected.includes(row));
      pinnedBottom = pinnedBottom.filter((row) => !selected.includes(row));
    }
    gridApi.setPinnedTopRowData(pinnedTop);
    gridApi.setPinnedBottomRowData(pinnedBottom);
  };

  const unPinAll = () => {
    gridApi.setPinnedTopRowData([]);
    gridApi.setPinnedBottomRowData([]);
  };

  return (
    <NavDropdown title={"Pin"} id={"nav-bar-pin"}>
      <NavDropdown.Item onClick={pinTop}>
        Pin selected rows to top
      </NavDropdown.Item>
      <NavDropdown.Item onClick={pinBottom}>
        Pin selected rows to bottom
      </NavDropdown.Item>
      <NavDropdown.Item onClick={unPinSelected}>
        Unpin selected rows
      </NavDropdown.Item>
      <NavDropdown.Item onClick={unPinAll}>
        Unpin all pinned rows
      </NavDropdown.Item>
    </NavDropdown>
  );
}

export default PinSelector;
